import React, { useState } from "react";
import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import PropTypes from "prop-types";
import moment from "moment";

/*istanbul ignore next */
const CollapsibleTable = ({ columns, data, filterData, handleSortingColumn}) => {
  const [openRows, setOpenRows] = useState({});

  const toggleRow = (id) => {
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const expandAll = () => {
    const all = {};
    data.forEach((row) => (all[row.id] = true));
    setOpenRows(all);
  };

  const collapseAll = () => setOpenRows({});

  const handleExpandCollapse = () => {
    const allExpanded = data.every((row) => openRows[row.id]);
    if (allExpanded) {
      collapseAll();
    } else {
      expandAll();
    }
  };

  return (
    <div className="main_content_table_history tableFixHead muiCollapsibleTable noBorder">
        {data.length > 0 && (
            <button className="btn cus-primary-transparent-btn" onClick={handleExpandCollapse}>{data.length > 0 && data.every((row) => openRows[row.id]) ? "Collapse" : "Expand"} All</button>
        )}
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell />
                        {columns.map((col) => (
                            <TableCell key={col.key}>
                                <button
                                    className={
                                        filterData?.sortColumn === col.key
                                            ? "active sortBtn"
                                            : "sortColumn sortBtn"
                                    }
                                    onClick={() => handleSortingColumn(col.key)}
                                >
                                    {col.label}
                                    <i
                                        className={
                                            filterData?.sortColumn === col.key &&
                                                filterData?.sortOrder === "ASCENDING"
                                                ? "fa fa-arrow-up"
                                                : "fa fa-arrow-down"
                                        }
                                        aria-hidden="true"
                                    ></i>
                                </button>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                {data.map((row) => (
                    <React.Fragment key={row.id}>
                        {/* Main Row */}
                        <TableRow>
                            <TableCell>
                            <IconButton className="iconCollapse" size="small" onClick={() => toggleRow(row.id)}>
                                {openRows[row.id] ? (
                                <i className="fa fa-chevron-down rotateIcon"/>
                                ) : (
                                    <i className="fa fa-chevron-down"/>
                                )}
                            </IconButton>
                            </TableCell>

                            {columns.map((col) => (
                                <TableCell key={col.key}>{row[col.key]}</TableCell>
                            ))}
                        </TableRow>

                        {/* Collapsible Row */}
                        <TableRow>
                            <TableCell colSpan={columns.length + 1} style={{ padding: 0, borderBottom: "none" }}>
                                <Collapse in={!!openRows[row.id]} timeout="auto" unmountOnExit>
                                    {row?.history?.length > 0 ? (
                                        <Box className="collapseTableDetails">
                                            <table className="details-table table">
                                                <thead>
                                                    <tr>
                                                        <th>&nbsp;</th>
                                                        <th>Date</th>
                                                        <th>Transaction Type</th>
                                                        <th>Profit</th>
                                                        <th>Carrier Rate</th>
                                                        <th>3PL Rate</th>
                                                        <th>Carrier Margin</th>
                                                        <th>3PL Margin</th>
                                                        <th>Reason</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {row?.history?.map((detail, index) => (
                                                        <tr key={detail.id}>
                                                            <td>&nbsp;</td>
                                                            <td>{moment(detail.createdDate).format("MM-DD-YYYY | h:mm:ss A")}</td>
                                                            <td>{detail.transactionType}</td>
                                                            <td>$ {detail.profit}</td>
                                                            <td>$ {detail.transactionAmount}</td>
                                                            <td>$ {detail.rate}</td>
                                                            <td>$ {detail.carrierAdminFee}</td>
                                                            <td>$ {detail.wmsAdminFee}</td>
                                                            <td className="taskTitle">{detail.reason}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </Box>
                                    ) : <div className="alignCenter p-2 noDetail">No Details Available</div>
                                    }
                                </Collapse>
                            </TableCell>
                        </TableRow>
                    </React.Fragment>
                ))}
                {data.length === 0 && (
                    <TableRow>
                        <TableCell colSpan={columns.length + 1} className="alignCenter p-2">
                            No Records Found
                        </TableCell>
                    </TableRow>
                )}
                </TableBody>
            </Table>
        </TableContainer>
    </div>
  );
};

CollapsibleTable.propTypes = {
    columns: PropTypes.array,
    data: PropTypes.array,
    filterData: PropTypes.object,
    handleSortingColumn: PropTypes.func
};

export default CollapsibleTable;
